import React from 'react';
import { Helmet } from 'react-helmet';

import { Hero } from './sections/hero';
import { Steps } from './sections/steps';
import { Loyalty } from './sections/loyalty';
import { Info } from './sections/info';

import '../../../assets/fonts/Nunito Sans/stylesheet.css';
import '../../../assets/fonts/AGLettericaExtraCompressed/stylesheet.css';
import './index.scss';

export const DownloadMobile = () => (
  <>
    <Helmet>
      <title>Скачать приложение БК Зенит на Android и iOS – мобильные ставки на спорт</title>
      <meta
        name="description"
        content="Официальное мобильное приложение БК Зенит для Android и iOS: ставки на спорт в любом месте, лайв-трансляции, быстрое пополнение счёта и вывод средств. Скачайте бесплатно на zenit.win."
      />
      <meta
        name="keywords"
        content="приложение зенит, скачать зенит на андроид, зенит apk, мобильное приложение бк зенит, зенит android, скачать букмекер зенит, зенит ios"
      />

      <meta
        property="og:title"
        content="Скачать приложение БК Зенит на Android и iOS – мобильные ставки на спорт"
      />
      <meta
        property="og:description"
        content="Официальное мобильное приложение БК Зенит для Android и iOS: ставки на спорт в любом месте, лайв-трансляции, быстрое пополнение счёта и вывод средств. Скачайте бесплатно на zenit.win."
      />
    </Helmet>

    <div className="download-mobile">
      <Hero />
      <Steps />
      <Loyalty />
      <Info />
    </div>
  </>
);
